import {EmailServerConfig} from "@/modules/sadmin";

const APP_CONFIG_URI = '/api/sadmin/app-config';
const APP_UI_CONFIG_URI = '/api/sadmin/ui-config';
const APP_INFO_URI = '/p/api/app-info';

export const AppConfigApi = {
    async saveEmailServerConfig(mailServerConfig){
        const response = await axios.post(`${APP_CONFIG_URI}`, mailServerConfig);
        return new EmailServerConfig(response.data);
    },
    async getEmailServerConfig(){
        const response = await axios.get(`${APP_CONFIG_URI}`);
        return new EmailServerConfig(response.data);
    },
    async getAppInfo(){
        const response = await axios.get(`${APP_INFO_URI}`);
        return response.data;
    },
    async saveAppUIConfig(uiConfig){
        const response = await axios.post(`${APP_UI_CONFIG_URI}`, uiConfig);
        return response.data;
    },
};
